import { toast } from "react-hot-toast";
import { QRCodeSVG } from 'qrcode.react';


export const copyToClipboard = (text) => {
	const doCopy = () => {
		if (navigator.clipboard?.writeText) {
			return navigator.clipboard.writeText(text);
		}
		const ta = document.createElement('textarea');
		ta.value = text;
		ta.style.cssText = 'position:fixed;left:-9999px';
		document.body.appendChild(ta);
		ta.select();
		document.execCommand('copy');
		document.body.removeChild(ta);
		return Promise.resolve();
	};

	doCopy().then(() => {
		toast((t) => (
			<span
				onClick={() => toast.dismiss(t.id)}
				data-tid={t.id}
				className="toastText">
				Copied to clipboard!
			</span>
		));

		document.addEventListener("click", (e) => {
			if (e.target.querySelector(".toastText")) {
				toast.dismiss(
					e.target.querySelector(".toastText").getAttribute("data-tid")
				);
			}
		});
	}).catch(() => {
		toast.error('Failed to copy to clipboard');
	});
};


export const qrToast = (text) => {
	toast((t) => {
		t.duration = 120000;

		return <span
			onClick={() => toast.dismiss(t.id)}
			data-tid={t.id}
			className="toastText">
			<QRCodeSVG value={text} size={186} />

		</span>
});

	document.addEventListener("click", (e) => {
		//if somewhere in the children of clicked element has class toastText, dismiss the toast
		if (e.target.querySelector(".toastText")) {
			toast.dismiss(
				e.target.querySelector(".toastText").getAttribute("data-tid")
			);
		}
	});
}

/**
 * Generates a title with superscript index if multiple instances of the same program exist
 * @param {string} baseTitle - The base title of the window
 * @param {string} progName - The program name to count instances for
 * @param {Array} windows - Array of all windows (both minimized and non-minimized)
 * @param {string} currentWindowId - ID of the current window
 * @returns {string} - Title with superscript index if needed
 */
export const getIndexedTitle = (baseTitle, progName, windows, currentWindowId) => {
	if (!windows || !progName) return baseTitle;
	
	// Find all windows with the same program name (including minimized ones)
	const sameProgWindows = windows.filter(window => 
		window.progName === progName
	);
	
	// If only one instance, return original title
	if (sameProgWindows.length <= 1) return baseTitle;
	
	// Find the index of current window (1-based)
	const sortedWindows = sameProgWindows.sort((a, b) => {
		// Sort by creation order (windowId or zIndex)
		return a.windowId.localeCompare(b.windowId);
	});
	
	const currentIndex = sortedWindows.findIndex(window => 
		window.windowId === currentWindowId || window.id === currentWindowId
	);
	
	if (currentIndex === -1) return baseTitle;
	
	// Generate superscript numbers
	const superscriptMap = {
		'0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴',
		'5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹'
	};
	
	const indexStr = (currentIndex + 1).toString();
	const superscriptIndex = indexStr.split('').map(digit => superscriptMap[digit] || digit).join('');
	
	return `${baseTitle}${superscriptIndex}`;
};
